import { render, staticRenderFns } from "./B2busers.vue?vue&type=template&id=2910ccba&scoped=true&"
import script from "./B2busers.vue?vue&type=script&lang=js&"
export * from "./B2busers.vue?vue&type=script&lang=js&"
import style0 from "./B2busers.vue?vue&type=style&index=0&id=2910ccba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910ccba",
  null
  
)

export default component.exports